import { useQuery } from "@tanstack/react-query";

// const url = process.env.REACT_APP_URL_DIR + "user";
const urlProd = process.env.REACT_APP_URL_DIR + "estadosproducto";

export function Estado() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["estados"],
      queryFn: () =>
         fetch(urlProd, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}



export default Estado;
